import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(ElementUI);

// 在应用启动时初始化 Vuex 状态，从 localStorage 恢复用户信息
store.dispatch('initializeStore').then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
});
